import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const JellyfishRoutes: RouteBundle = {
  domain: 'app-core',
  routes: [
    {urlPattern: 'jellyfish/listing', handler: EditorRoutes.jellyfish.bind(EditorRoutes)},
    {urlPattern: 'jellyfish/:id', handler: EditorRoutes.jellyfishEditor.bind(EditorRoutes)},
  ],
};
